import { Dialog } from "@headlessui/react";
import React from "react";
import { FiMenu } from "react-icons/fi";
import Sidebar from "../Demo/Sidebar";

export const MobileMenu = () => {
  let [isOpen, setIsOpen] = React.useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <div className='mobile-menu-wrapper'>
      <button className='mobile-menu-btn' onClick={openModal}>
        <FiMenu color='#71797E' size={24} />
      </button>
      <Dialog
        as='div'
        className='mobile-menu-dialog'
        open={isOpen}
        onClose={closeModal}
      >
        <div className='mobile-menu-ovelay' />
        <div className='mobile-menu-outer'>
          <div className='mobile-menu-inner'>
            <Dialog.Panel className='mobile-menu-panel'>
              <Sidebar />
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
